import { css } from "styled-components";
import { fontSize14, fontSize16, spacing16, spacing8, spacing4, text120, sans, lineHeightTight, fontWeightNormal, borderRadius, setAppearanceConstantLocal, whiteTransparency30, whiteTransparency70, grey90 } from "@churchofjesuschrist/eden-style-constants";
import { adjustHexAlpha } from "@churchofjesuschrist/eden-utilities";
export const paddingBlockStartEnd = spacing4;
export const paddingInlineStartEnd = spacing16;
const [buttonDisabledDef, buttonDisabled] = setAppearanceConstantLocal("button-disabled", {
  light: adjustHexAlpha(text120, 0.38),
  dark: whiteTransparency30,
  prefix: "eden"
});
const [buttonDisabledBackgroundDef, buttonDisabledBackground] = setAppearanceConstantLocal("button-disabled-background", {
  light: adjustHexAlpha(grey90, 0.12),
  dark: whiteTransparency70,
  prefix: "eden"
});
const shared = css(["", ";", ";text-transform:none;overflow:visible;display:inline-flex;gap:calc(", " + ", ");align-items:center;justify-content:center;margin:0;border:0;border-radius:", ";cursor:pointer;font-weight:", ";", ";vertical-align:top;text-decoration:none;padding:", " ", ";font-family:", ";line-height:", ";color:", ";& > svg{width:1.5rem;height:1.5rem;margin:0 -", ";flex-shrink:0;}", ";@media (hover:hover){&:hover{color:", ";text-decoration:none;}}&[disabled],&[disabled]:hover{background-color:", ";color:", ";border-color:", ";cursor:not-allowed;}"], buttonDisabledDef, buttonDisabledBackgroundDef, spacing8, spacing4, borderRadius, fontWeightNormal, _ref => {
  let {
    fullWidth
  } = _ref;
  return fullWidth ? "width: 100%" : "width: fit-content; max-width: 18rem";
}, paddingBlockStartEnd, paddingInlineStartEnd, sans, lineHeightTight, text120, spacing8, _ref2 => {
  let {
    small
  } = _ref2;
  return small ? `font-size: ${fontSize14}; 
        min-height: 2rem;
        ` : `font-size: ${fontSize16};
        min-height: 2.5rem;
        `;
}, text120, buttonDisabledBackground, buttonDisabled, buttonDisabledBackground);
export default shared;